import webClient from "../config/api.config";
import { FaqPayloadVM } from "../types/faq.definition";

export function requestGetFaqs(
  lang: string = "fr",
  page: number = 0,
  size: number = 10
) {
  return webClient.request({
    method: "get",
    url: `/faqs`,
    params: { lang, page, size },
  });
}

export function requestGetFaqById(id: number, lang: string = "fr") {
  return webClient.request({
    method: "get",
    url: `/faqs/${id}`,
    params: { lang },
  });
}

export function requestCreateFaq(data: FaqPayloadVM) {
  return webClient.request({
    method: "post",
    url: `/faqs`,
    data,
  });
}

export function requestUpdateFaq(id: number, data: FaqPayloadVM) {
  return webClient.request({
    method: "put",
    url: `/faqs/${id}`,
    data,
  });
}

export function requestDeleteFaq(id: number) {
  return webClient.request({
    method: "delete",
    url: `/faqs/${id}`,
  });
}

export function requestGetFaqChildren(parentId: number, lang: string = "fr") {
  return webClient.request({
    method: "get",
    url: `/faqs/${parentId}/children`,
    params: { lang },
  });
}
